import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = ["value"]

import { Direction } from "@/models/Directon";
import { Position } from "@/models/Position";
import { Rover } from "@/models/Rover";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'GameRoverDeploy',
  emits: ["deployRover"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const x = ref(100);
const y = ref(100);
const direction = ref<Direction>(0);

const deployRover = () => {
  const position = new Position(x.value, y.value);
  const rover = new Rover(position, direction.value);
  emit("deployRover", rover);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("label", null, "Initial Position (x, y, direction):", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((x).value = $event)),
        type: "number",
        placeholder: "X"
      }, null, 512), [
        [
          _vModelText,
          x.value,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((y).value = $event)),
        type: "number",
        placeholder: "Y"
      }, null, 512), [
        [
          _vModelText,
          y.value,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((direction).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(Direction)).filter(k => typeof _unref(Direction)[k as any] === 'number'), (itype) => {
          return (_openBlock(), _createElementBlock("option", {
            key: itype,
            value: _unref(Direction)[itype as keyof typeof Direction]
          }, _toDisplayString(itype.toString()), 9, _hoisted_1))
        }), 128))
      ], 512), [
        [_vModelSelect, direction.value]
      ])
    ]),
    _createElementVNode("button", { onClick: deployRover }, "Deploy Rover")
  ], 64))
}
}

})